import {localizedMessage} from '../message/Message';
import React from 'react';

const RedeemSectionPsnWarning = () => {
  return (
    <span className="psnWarning">
      {localizedMessage('errors.com.epicgames.posa.psn.country.not.supported')}
    </span>
  );
};

export default RedeemSectionPsnWarning;
